import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import BlockTypes from '../../types/BlockTypes';
import { normalizeNode, shouldBeAtRoot } from '../utils/NormalizationHelper';
import renderBlocks from '../utils/renderBlocks';
import makeToolbarButton, { EXPANDED_INSERTION } from '../utils/makeToolbarButton';
import EmbeddableTypes from '../../types/EmbeddableTypes';
import makeOnKeyDown from './handlers/makeOnKeyDown';
import makeOnPasteHandler from './handlers/makeOnPasteHandler';
import onSubmitHandler from './handlers/onSubmit';
import EmbedPlaceholderComponent from './components/EmbedPlaceholder';
import { getEmbedInformationsList } from './config';
import createStore from '../utils/createStore';
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$getApplications = _ref.getApplications,
      getApplications = _ref$getApplications === void 0 ? function () {
    return [];
  } : _ref$getApplications,
      _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === void 0 ? function (component) {
    return component;
  } : _ref$decorator;

  var embedsCommandPickers = getEmbedInformationsList().filter(function (e) {
    return e.id !== EmbeddableTypes.DEFAULT;
  }).map(function (_ref2) {
    var id = _ref2.id,
        title = _ref2.title,
        description = _ref2.description,
        iconGrey = _ref2.iconGrey,
        iconActive = _ref2.iconActive;
    return makeToolbarButton(id, {
      id: id,
      icon: iconGrey,
      iconActive: iconActive,
      title: title,
      canApply: function canApply(editor) {
        return editor.isMutableBlock();
      },
      onApply: function onApply(editor) {
        return editor.command('addEmbedPlaceholder', id);
      },
      visibility: EXPANDED_INSERTION
    });
  });
  var store = createStore({});
  var Component = decorator(EmbedPlaceholderComponent);
  return [normalizeNode(BlockTypes.EMBED_PLACEHOLDER, [shouldBeAtRoot]), _objectSpread({}, renderBlocks(_defineProperty({}, BlockTypes.EMBED_PLACEHOLDER, function (props) {
    var node = props.node,
        editor = props.editor;
    var type = node.data.get('embedType') || EmbeddableTypes.DEFAULT;
    return React.createElement(Component, Object.assign({
      pluginStore: store,
      embedType: type,
      onSubmit: function onSubmit(text) {
        var extractorsSelectorFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
          return true;
        };
        onSubmitHandler(node, text, editor, extractorsSelectorFilter);
      }
    }, props));
  })), {
    onPaste: makeOnPasteHandler(getApplications),
    onKeyDown: makeOnKeyDown(store),
    commands: {
      addEmbedPlaceholder: function addEmbedPlaceholder(editor) {
        var embedType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EmbeddableTypes.DEFAULT;
        var currentNode = editor.value.startBlock;
        var currentNodeIsEmpty = editor.isEmptyBlock(currentNode);

        if (!currentNodeIsEmpty) {
          editor.splitBlock().focus();
        }

        editor.setBlocks({
          type: BlockTypes.EMBED_PLACEHOLDER,
          data: {
            embedType: embedType
          }
        });
      }
    }
  })].concat(_toConsumableArray(embedsCommandPickers));
});